import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToAction() {
  return <section data-section-id="125644" id="get-a-quote-calltoaction" className="bg-background text-foreground py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-[radial-gradient(circle_at_center,_var(--color-secondary)_0%,_black_100%)]">
      <div className="max-w-5xl mx-auto bg-transparent rounded-[8px] border-y border-primary/30 p-10 md:p-20 flex flex-col items-center text-center shadow-2xl backdrop-blur-sm">
        <h2 className="font-serif font-bold bg-gradient-to-b from-[hsl(45,80%,70%)] to-[hsl(45,80%,40%)] bg-clip-text text-transparent text-3xl md:text-5xl lg:text-6xl tracking-tight mb-6 max-w-3xl">
          Ready to Elevate Your Home?
        </h2>
        
        <p className="font-sans text-white/90 text-lg md:text-xl mb-10 max-w-2xl leading-relaxed">
          Join the elite homeowners who trust our architectural vision to transform their living spaces into timeless masterpieces.
        </p>
        
        <Button asChild size="lg" className="bg-gradient-to-r from-[hsl(45,80%,60%)] to-[hsl(45,80%,40%)] text-primary-foreground hover:opacity-90 transition-all duration-500 hover:shadow-[0_0_30px_rgba(218,165,32,0.4)] text-base px-8 h-14 rounded-full relative overflow-hidden group">
          <Link to="#">
            <span className="relative z-10 flex items-center">
              Start Your Journey
              <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
            </span>
            <span className="absolute inset-0 bg-white/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000 skew-x-12" />
          </Link>
        </Button>
      </div>
    </section>;
}